var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSendPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    "aria-label": "Send Points",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1992 19.0306C14.025 19.0306 13.8509 18.9665 13.7134 18.829C13.4475 18.5631 13.4475 18.1231 13.7134 17.8573L18.3059 13.2648C18.5717 12.999 19.0117 12.999 19.2775 13.2648C19.5434 13.5306 19.5434 13.9706 19.2775 14.2365L14.685 18.829C14.5475 18.9573 14.3734 19.0306 14.1992 19.0306Z",
    fill: "#525252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7916 14.4287H3.20831C2.83248 14.4287 2.52081 14.117 2.52081 13.7412C2.52081 13.3654 2.83248 13.0537 3.20831 13.0537H18.7916C19.1675 13.0537 19.4791 13.3654 19.4791 13.7412C19.4791 14.117 19.1675 14.4287 18.7916 14.4287Z",
    fill: "#525252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20834 8.94665C3.03417 8.94665 2.86001 8.88249 2.72251 8.74499C2.45667 8.47915 2.45667 8.03915 2.72251 7.77332L7.31501 3.18082C7.58084 2.91499 8.02084 2.91499 8.28667 3.18082C8.55251 3.44665 8.55251 3.88665 8.28667 4.15249L3.69417 8.74499C3.56584 8.87332 3.38251 8.94665 3.20834 8.94665Z",
    fill: "#525252"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7916 8.94629H3.20831C2.83248 8.94629 2.52081 8.63462 2.52081 8.25879C2.52081 7.88296 2.83248 7.57129 3.20831 7.57129H18.7916C19.1675 7.57129 19.4791 7.88296 19.4791 8.25879C19.4791 8.63462 19.1675 8.94629 18.7916 8.94629Z",
    fill: "#525252"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendPoints);
export default __webpack_public_path__ + "static/media/send-points.558279cd3a080c65ebb792c08dcc8832.svg";
export { ForwardRef as ReactComponent };